// extracted by mini-css-extract-plugin
export default {"BreakWord":"TextNode_BreakWord__XmISQ","Ellipsis":"TextNode_Ellipsis__pcBIv","NoWrap":"TextNode_NoWrap__iqOKo"};